import React from 'react';
import moment from 'moment-timezone';
import { useFormContext } from 'react-hook-form';

import { DatesSlider } from '@common/components/DatesSlider';

import { DiningOption, PackagesFormValues } from '../../types';
import { usePackageConfiguration } from '../../contexts';

type TableVisitDateFormProps = {
  checkAllDays?: boolean;
  diningOptions: { date: string; options: DiningOption[] }[];
};

export const TableVisitDateForm = ({
  checkAllDays = false,
  diningOptions,
}: TableVisitDateFormProps): JSX.Element => {
  const { watch } = useFormContext<PackagesFormValues, any>();
  const { journeyParams } = usePackageConfiguration();

  const visitDateRangeStart = watch(`visitDate`) || journeyParams.fromDate;

  const diningOptionDates = diningOptions
    .filter((opt) => opt.options.length > 0)
    .map(({ date }) => ({ date: moment(date) }));

  return (
    <>
      <DatesSlider
        checkAllDays={checkAllDays}
        input={{
          onChange: () => {},
          value: moment(),
        }}
        visitDate={moment(visitDateRangeStart)}
        dates={diningOptionDates ?? []}
        isLoading={false}
        telephoneOnly={false}
        displayOnly
      />
    </>
  );
};
